// extracted by mini-css-extract-plugin
module.exports = {"TextFilter":"Text_TextFilter__DUQ8p"};